import { BaseDialog } from "@/lib/Components/Dialog/BaseDialog";
import { RelocationSummaryCard } from "@/app/Relocations/Components/RelocationSummaryCard";
import { RelocationAdditionalDestinationsGrid } from "@/app/Relocations/Components/RelocationAdditionalDestinationsGrid";

export function RelocationAdditionalDestinationDialog({
  relocationId,
}: {
  relocationId: string;
}) {
  return (
    <BaseDialog title="Additional destinations">
      <RelocationSummaryCard relocationId={relocationId} />
      <RelocationAdditionalDestinationsGrid relocationId={relocationId} />
    </BaseDialog>
  );
}
